import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import { Icon } from "../ui/Icons";
import { RevealGroup, revealItemVariants } from "../ui/Reveal";
import "./Advantages.css";

function Advantages() {
  const { advantages } = useContent();

  return (
    <section id="ventajas" className="section section--alt advantages">
      <div className="container">
        <div className="section-head center">
          <span className="eyebrow">{advantages.eyebrow}</span>
          <h2 className="section-title">{advantages.title}</h2>
        </div>

        <RevealGroup className="advantages-grid" stagger={0.08}>
          {advantages.items.map((item) => (
            <motion.article
              className="advantages-card"
              variants={revealItemVariants}
              key={item.id}
            >
              <span className="advantages-icon">
                <Icon name={item.icon} size={26} />
              </span>
              <h3 className="advantages-card-title">{item.title}</h3>
              <p className="advantages-card-text">{item.text}</p>
            </motion.article>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}

export default Advantages;
